
import WithColorMixin from '@/mixins/WithColorMixin.vue';
import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: 'FlagLabel',
    emits: ["discardMetric"],
    props: {
        label: {
            type: String
        },
        fontColor: {
            type: String,
            default: "black"
        },
        active: {
            type: Boolean,
            default: false
        },
        hideDiscardButton: {
            type: Boolean,
            default: false
        },
    },
    mixins: [WithColorMixin],
    computed: {
        labelFontColor(): string {
            return `var(--${this.fontColor})`;
        }
    },
    methods: {
        discard ()  {
            this.$emit("discardMetric", this.label)
        },
    }
});


import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "7501e732": (_ctx.lightColor),
  "10a696f6": (_ctx.labelFontColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__